import { InviteScreen } from '@/features/referrals/InviteScreen';

export function InvitePage() {
  return (
    <main className="flex flex-col">
      <h1 className="px-6 pt-8 font-display text-h1 text-text">Пригласить друга</h1>
      <InviteScreen />
    </main>
  );
}
